import { FC, useState } from 'react';
import { DatePicker } from '@mui/x-date-pickers';
import { parseISO, isValid } from 'date-fns';
import FormControl from '../form-control';
import { FormProps, getMuiSize } from '../helpers';
import { DateBound, resolveDateBound } from '@/lib/helpers';

interface Props extends FormProps {
  value: null | string | Date;
  onChange: (value: Date | null) => void;
  minDate?: DateBound;
  maxDate?: DateBound;
}

const DateInput: FC<Props> = ({
  name,
  label = '',
  onChange,
  value,
  error = '',
  autoFocus = false,
  disabled = false,
  minDate = '',
  maxDate = '',
  size = 'medium',
}) => {
  const [dateIsValid, setDateIsValid] = useState(true);

  const [resolvedMin, setResolvedMin] = useState(() => resolveDateBound(minDate));
  const [resolvedMax, setResolvedMax] = useState(() => resolveDateBound(maxDate));

  const handleOpen = () => {
    setResolvedMin(resolveDateBound(minDate));
    setResolvedMax(resolveDateBound(maxDate));
  };

  const handleChange = (value: Date) => {
    const updatedIsValid = !value || isValid(value);
    setDateIsValid(updatedIsValid);
    onChange(updatedIsValid ? value : null);
  };

  const dateVal = value && typeof value === 'string' ? parseISO(value) : value;
  const hasError = !dateIsValid || Boolean(error);

  return (
    <FormControl label="" error={hasError ? error : ''} name={name}>
      <DatePicker
        value={dateVal || null}
        name={name}
        label={label}
        onChange={handleChange}
        onOpen={handleOpen}
        autoFocus={autoFocus}
        disabled={disabled}
        minDate={resolvedMin}
        maxDate={resolvedMax}
        className=""
        slotProps={{ textField: { size: getMuiSize(size) } }}
      />
    </FormControl>
  );
};

export default DateInput;
